<template>
  <div class="h-8 half_circle title-bg">
    <p class="title text-center text-white font-semibold pt-1 pb-2">
      {{ platformName }}
    </p>
  </div>
  <div
    class="mx-2 -mt-5 w-36 h-18 bg-white filter drop-shadow-lg"
    v-if="loading"
  >
    <img src="@/assets/loading.png" class="w-full h-full" />
  </div>
  <div class="mx-2 -mt-5 w-36 h-18 filter drop-shadow-lg" v-else>
    <img-swiper :list="swiperList"></img-swiper>
  </div>

  <div class="flex justify-center">
    <van-notice-bar
      @click="showPopup"
      class="mt-0.5 w-16 h-4 bg-yellow-50"
      :scrollable="false"
      left-icon="warning-o"
      text="查看预约规则"
    />
  </div>

  <div class="mx-1 shadow-md">
    <van-grid clickable :column-num="menuNum">
      <van-grid-item
        v-if="enableSeat"
        icon="manager"
        text="座位预约"
        @click="goBooking(1)"
      />
      <van-grid-item
        icon="friends"
        v-if="enableRoom"
        text="研讨室预约"
        @click="goBooking(2)"
      />
      <van-grid-item icon="like" text="常用预约" v-if="enableSeat || enableRoom" @click="goBooking(3)" />
      <van-grid-item icon="wap-home" text="入馆预约" v-if="enableEntrance" @click="goBooking(4)" />
    </van-grid>
  </div>
  <div class="mx-1 mt-1" v-if="(currentBookings.length === 0) && (enableRoom || enableSeat)">
    <div>
      <van-tag size="large" type="danger">请先预约空间</van-tag>
    </div>
    <div
      class="
        flex
        justify-center
        items-center
        rounded-sm
        middle-text
        font-bold
        bg-white
        h-10
        w-full
      "
    >
      <span>您当前没有预约信息</span>
    </div>
  </div>
  <div class="mx-1 mt-1" v-else>
    <van-swipe :loop="false">
      <van-swipe-item  v-for="currentBooking in currentBookings" :key="currentBooking.id">
        <div class="flex justify-between">
          <van-tag size="large" type="danger">{{
            currentBooking.statusname
          }}</van-tag>
          <router-link to="/index/my"
            ><span class="small-text text-gray-400"
              >查看全部预约<van-icon name="arrow" /></span
          ></router-link>
        </div>
        <div class="p-1 rounded-sm bg-white">
          <div class="flex justify-between">
            <div class="">
              <span class="small-text whitespace-normal">{{
                currentBooking.isSingle == 1
                  ? currentBooking.nameMerge.replaceAll(" ", "") +
                    ":" +
                    currentBooking.spaceName
                  : currentBooking.nameMerge
              }}</span>
            </div>
            <div
              v-if="currentBooking.isSingle && currentBooking.flag_leave == 0"
            >
              <span class="smaller-text ml-2 text-red-700 whitespace-nowrap"
                >已使用{{
                  currentBooking.flag_in == 1 ? 0 : passedTime
                }}分钟</span
              >
            </div>
            <div v-else></div>
          </div>
          <div v-if="currentBooking.flag_leave === 1 && currentBooking.flag_in===1">
            <span class="small-text text-red-500 whitespace-nowrap"
              >请在{{
                currentBooking.needBackTime.date.substr(0, 16)
              }}分之前返回签到</span
            >
          </div>
          <div v-else class="h-1"></div>
          <div v-if="currentBooking.signIn === 0">
            <span class="small-text text-red-500 whitespace-nowrap"
              >请在{{ currentBooking.lastsignintime }}分之前签到</span
            >
          </div>
          <div v-else class="h-1"></div>
          <div
            class="flex flex-row flex-nowrap"
            :class="[
              { 'justify-between': currentBooking.isSingle == 1 },
              'justify-end',
            ]"
          >
            <div class="flex-1" v-if="currentBooking.isSingle">
              <span class="small-text text-gray-400" @click="showMap"
                >座位示意图&nbsp;&gt;</span
              >
            </div>
            <!---
                oksign=1,显示取消按钮
                flag_in=1,显示签到
                flag_out=1,显示临时离开和签离
                flag_leave=1,显示返回签到
              --->
            <div
              class="flex-none"
              v-if="
                currentBooking.flag_out === 1 &&
                currentBooking.SYS_WEB_MYYUYUE_RIGHTBACK == 1
              "
            >
              <van-button
                type="primary"
                size="small"
                @click="changeBookStatus('leave', currentBooking.id)"
                >临时离开</van-button
              >
            </div>
            <div
              class="flex-none ml-2"
              v-if="
                currentBooking.flag_out === 1 &&
                currentBooking.SYS_WEB_MYYUYUE_LEAVE == 1
              "
            >
              <van-button
                type="danger"
                size="small"
                @click="changeBookStatus('checkout', currentBooking.id)"
                >完全离开</van-button
              >
            </div>
            <div
              class="flex-none"
              v-if="
                currentBooking.flag_in === 1 &&
                currentBooking.SYS_WEB_MYYUYUE_RIGHTBACK == 1 &&
                currentBooking.flag_leave == 1
              "
            >
              <van-button
                type="success"
                size="small"
                @click="changeBookStatus('checkin', currentBooking.id)"
                >返回签到</van-button
              >
            </div>
            <div
              class="flex-none"
              v-if="
                currentBooking.signIn === 0 &&
                currentBooking.SYS_WEB_MYYUYUE_SIGNIN == 1
              "
            >
              <van-button
                type="success"
                size="small"
                @click="changeBookStatus('checkin', currentBooking.id)"
                >签到</van-button
              >
            </div>
            <div class="flex-none ml-2" v-if="currentBooking.oksign === 1">
              <van-button
                type="warning"
                size="small"
                @click="changeBookStatus('delete', currentBooking.id)"
                >取消预约</van-button
              >
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
  <!------通知------>
  <div class="mx-1 mt-1" v-if="sysconfig.SYS_SITE_GONGGAO == 1">
    <div class="flex justify-between">
      <span class="small-text">公告通知</span>
      <router-link to="/listNotices"
        ><span class="small-text text-gray-400"
          >查看全部通知<van-icon name="arrow"
        /></span>
      </router-link>
    </div>
    <div
      class="
        flex
        justify-center
        items-center
        rounded-sm
        middle-text
        font-bold
        bg-white
        h-8
        w-full
      "
      v-if="notices.length == 0"
    >
      <span>当前暂无通知</span>
    </div>
    <div class="p-1 rounded-sm bg-white grid gap-y-1 grid-cols-1" v-else>
      <div
        @click="showNotice(notice.id)"
        class="justify-self-start"
        v-for="(notice, idx) in notices"
        :key="idx"
      >
        <span class="small-text text-gray-500"
          >{{ notice.title }}（{{ notice.inputTime.slice(0, 10) }}）</span
        >
      </div>
    </div>
  </div>
  <!------活动------>
  <div class="mx-1 mt-1 mb-8" v-if="sysconfig.SYS_SITE_HUODONG == 1">
    <div class="flex justify-between">
      <span class="small-text">当前活动</span>
      <router-link to="/listEvents"
        ><span class="small-text text-gray-400"
          >查看全部活动<van-icon name="arrow" /></span
      ></router-link>
    </div>
    <div
      class="
        flex
        justify-center
        items-center
        rounded-sm
        middle-text
        font-bold
        bg-white
        h-8
        w-full
      "
      v-if="events.length == 0"
    >
      <span>当前暂无活动</span>
    </div>
    <div class="p-1 rounded-sm bg-white" v-else>
      <div
        class="grid grid-cols-4 gap-y-0"
        v-for="(event, idx) in events"
        :key="idx"
        @click="goEventDetail(event.id)"
      >
        <div class="justify-self-start col-span-3">
          <span class="small-text text-gray">{{ event.title }}</span>
        </div>
        <div class="row-span-3">
          <van-image width="80" height="80" lazy-load :src="event.filePath" />
        </div>
        <div class="justify-self-start col-span-3">
          <span class="small-text text-gray-500">地点：{{ event.place }}</span>
        </div>
        <div class="justify-self-start col-span-3">
          <span class="small-text text-gray-500"
            >时间：{{ event.beginTime.slice(5, 16) }}-{{
              event.endTime.slice(11, 16)
            }}</span
          >
        </div>
        <div class="justify-self-start col-span-3">
          <span class="small-text text-gray-500"
            >报名截止：{{ event.deadline.slice(5, 16) }}</span
          >
          <van-divider class="mt-0.5 mb-0.5" />
        </div>
      </div>
    </div>
  </div>
  <!------预约规则------->
  <van-popup
    class="popup rounded-sm"
    v-model:show="showRules"
    closeable
    close-icon="close"
  >
    <ol class="popup-content p-2 list-none">
      <p class="middle-text font-bold">预约规则</p>
      <li style="line-height: 1.75em" v-for="(rule, idx) in rules" :key="idx">
        <div v-html="rule" />
      </li>
    </ol>
  </van-popup>
  <van-image-preview
    v-model:show="mapShown"
    min-zoom="1"
    :images="[`/figure/${school}/${area}/seat-free.jpg`]"
  >
  </van-image-preview>
</template>

<script>
import { reactive, onMounted, toRefs, ref } from "vue";
import { useRouter } from "vue-router";
import ImgSwiper from "@/components/ImgSwiper";
import { Dialog, Toast } from "vant";
import qs from "qs";
import _ from "lodash";
//import dayjs from "dayjs";
import Cookies from "js-cookie";
//import to from 'await-to-js';
import {
  getRules,
  getSwipes,
  getNotices,
  getEvents,
  getCurrentUse,
  changeBook,
  getSysConfig,
  //getServerTime,
} from "@/service/home";
//import { myStorage } from "@/utils/util";

export default {
  name: "home",
  components: {
    ImgSwiper,
  },
  setup() {
    const user = JSON.parse(Cookies.get("user"));
    const enableRoom = JSON.parse(Cookies.get("school")).enableRoom;
    const enableSeat = JSON.parse(Cookies.get("school")).enableSeat;
    const enableEntrance = JSON.parse(Cookies.get("school")).enableEntrance;
    let menuCount = 0;
    if (enableRoom) {
      menuCount++;
    }
    if (enableSeat) {
      menuCount++;
    }
    if (enableEntrance) {
      menuCount++;
    }
    if (enableRoom || enableSeat) {
      menuCount++;
    }
    if (menuCount>3) {
      menuCount = 2;
    }
    const platformName = JSON.parse(Cookies.get("school")).platformName;
    const school = JSON.parse(Cookies.get("school")).school;
    const router = useRouter();
    const area = ref(0);
    const state = reactive({
      swiperList: [], // 轮播图列表
      rules: [],
      notices: [],
      events: [],
      currentBookings: [],
      showRules: false,
      loading: true,
      enableRoom: enableRoom,
      enableSeat: enableSeat,
      enableEntrance : enableEntrance,
      platformName: platformName,
      passedTime: 0,
      mapShown: false,
      sysconfig: {},
      school: school,
      openTime: {},
      menuNum:menuCount
    });

    const showPopup = () => {
      state.showRules = !state.showRules;
    };
    const showNotice = async (id) => {
      router.push({ name: "noticeDetail", params: { id: id } });
    };
    const goEventDetail = (id) => {
      router.push({ name: "eventDetail", params: { id: id } });
    };
    const goBooking = async (type) => {
      if (type == 1) {
        router.push("/chooseSpace");
      } else if (type == 2) {
        // 预约研讨就
        router.push("/chooseRoom");
      } else if (type == 3) {
        // 常用预约
        router.push("/bookFavorite");
      } else if (type == 4) {
        // 入馆预约
        router.push("/bookEntrance");
      }
    };
    const changeBookStatus = async (method, bookId) => {
      try {
        const result = await changeBook(
          bookId,
          qs.stringify({
            id: bookId,
            _method: method,
            access_token: user.access_token,
            userid: user.userid,
            operateChannel: 3,
          })
        );
        if (result.status == 1) {
          Dialog.alert({
            title: "提示",
            allowHtml: true,
            message: result.msg,
          }).then(() => {
            loadCurrentBooking();
          });
        } else {
          throw new Error(result.msg);
        }
      } catch (error) {
        Dialog.alert({
          title: "提示",
          allowHtml: true,
          message: error.message,
        }).then(() => {});
      }
    };
    const showMap = () => {
      state.mapShown = !state.mapShown;
    };
    const loadCurrentBooking = async () => {
      let currentSeatBooking = await getCurrentUse({
        user: user.userid,
      });
      if (currentSeatBooking && currentSeatBooking.length > 0) {
        area.value = currentSeatBooking[0].areaid;
        let difference =
          new Date().getTime() -
          new Date(
            currentSeatBooking[0].signintime.replace(/-/g, "/")
          ).getTime();
        state.passedTime = parseInt(difference / 1000 / 60);
      }
      let currentRoomBooking = await getCurrentUse({
        user: user.userid,
        type: 2,
      });
      state.currentBookings = _.concat(currentSeatBooking, currentRoomBooking);
    };
    onMounted(async () => {
      try {
        state.sysconfig = await getSysConfig();
        state.rules = await getRules();
        state.swiperList = await getSwipes();
        //state.openTime = await getOpenTime();
        const {
          data: { list: notices },
        } = await getNotices();
        state.notices = notices;
        const {
          data: { list: events },
        } = await getEvents();
        state.events = events.filter((event) => event.status == 2).slice(0, 2);
        await loadCurrentBooking();
        state.loading = false;
      } catch (error) {
        if (error instanceof TypeError) {
          Toast({
            message: '暂无数据',
            forbidClick: true,
            overlay: true,
        });
        } else {
          Toast({
            message: '系统繁忙，请稍后',
            forbidClick: true,
            overlay: true,
        });
        }
      }
    });

    return {
      ...toRefs(state),
      showPopup,
      showNotice,
      showMap,
      goEventDetail,
      goBooking,
      changeBookStatus,
      area,
    };
  },
};
</script>

<style lang="less">
@import "../common/style/base";

.popup {
  display: flex;
  height: 60%;
  width: 80%;
}
.popup-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  font-size: 16px;
}
.van-popup {
  overflow-y: visible;
}
.van-popup__close-icon {
  top: calc(100% + 10px);
  top: -webkit-calc(100% + 10px);
  left: 45%;
  font-size: 32px;
}
.van-grid-item__text {
  font-size: 16px;
}
.van-grid-item__icon {
  color: #49cfd4;
}
.van-skeleton__row {
  background-color: rgb(188, 229, 248);
}
.van-swipe__indicators {
  bottom: 0.1rem;
}
.van-toast--fail {
  width: 30%;
}
</style>
